import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-retrieval-summary-escalations",
  templateUrl: "./retrieval-summary-escalations.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RetrievalSummaryEscalationsComponent {
  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.RetrievalSummaryEscalationsDW;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, HideFilters.PROJECT_NAME2, "Customer_Name", HideFilters.PROJECT_TYPE_ID2];
}
